export default "__VITE_ASSET__BWu8TnGb__"